<template>
  <div style="width:100%;">
    <Select
      :placeholder="'Tags'"
      :value="value"
      multiple
      :max-tag-count="4"
      @on-select="onSelect"
      style="width: 100%"
      :size="size"
    >
      <OptionGroup
        :label="$t(`${key}`)"
        v-for="(item, key) in $store.state.interest_setting"
        :key="key"
      >
        <Option v-for="i in item.data" :value="i.key" :key="i.key">{{
          $t(`preferences_setting.${i.key}`)
        }}</Option>
      </OptionGroup>
    </Select>
  </div>
</template>

<script>
export default {
  name: "interest-tag-select",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "default"
    }
  },
  methods: {
    validate(){
      let errMsg = ""
      let flag = Object.keys(this.$store.state.interest_setting).every((key,index) => {
        let item = this.$store.state.interest_setting[key].data
        if(item.some(i => this.value.includes(i.key))){
          return true
        } else {
          errMsg = this.$t(`preferences_setting.tip_err_${index+1}`)
        }
        // if (this.interest_setting[key].selectItems.length == 0) {
        //   // this.interest_setting[key].errMessage = true;
        //    if (index === 0) {
        //      this.$Message.error(this.$t('preferences_setting.tip_err_1'))
        //     }else if (index === 1) {
        //     this.$Message.error(this.$t('preferences_setting.tip_err_2'))
        //     }else if(index === 2){
        //      this.$Message.error(this.$t('preferences_setting.tip_err_3'))
        //    }
        //   validate_tags = false;
        // } else {
        //   validate_tags = true;
        // }
      });
      return {flag,errMsg}
    },
    onSelect(item) {
      console.log(item, "SDAD");
      const targetIndex = this.value.findIndex(i => i == item.value);
      // console.log(target, "target")
      if (targetIndex != -1) {
        this.value.splice(targetIndex, 1);
      } else {
        this.value.push(item.value);
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/interest_tag_select/index.vue